export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="bg-background-100/80 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-shrink-0">
            <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-secondary-100 flex items-center justify-center">
              <i className="ri-mail-send-line text-3xl md:text-4xl text-secondary-600"></i>
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-[560px]">
              如果您有动漫资源投稿、合作建议或遇到任何使用问题，欢迎通过以下方式联系我们。51动漫官网团队将尽快回复您的反馈，共同打造更好的动漫追更体验。
            </p>
          </div>
          <div className="flex-shrink-0 flex flex-col sm:flex-row gap-3">
            <a
              href="#faq"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-5 py-2.5 border border-background-300 text-foreground-700 font-medium text-sm rounded-full hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-customer-service-2-line text-lg"></i>
              常见问题
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}